module.exports = __webpack_public_path__ + "resources/icon_50_block.3cc0ca298f33a281.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_50_block.png
// module id = 479
// module chunks = 0 1 2 3 4